<script setup>
import { computed } from 'vue'

const props = defineProps({
  indicator: {
    type: Object,
    default: () => ({ label: 'Unknown' }),
  },
  source: {
    type: String,
    default: 'reconciliation',
  },
})

const tone = computed(() => {
  if (props.indicator?.hasMismatch) return 'warning'
  if (props.indicator?.degraded || props.indicator?.partial) return 'info'
  return 'success'
})

const severity = computed(() => {
  if (tone.value === 'warning') return 'high'
  if (tone.value === 'info') return 'medium'
  return 'low'
})
</script>

<template>
  <span class="reconciliation-badge" :class="`tone-${tone}`">
    <span class="label">{{ indicator?.label || 'Unknown' }}</span>
    <span class="meta">severity: {{ severity }}</span>
    <span class="meta">source: {{ source }}</span>
  </span>
</template>

<style scoped>
.reconciliation-badge { display: inline-flex; gap: 0.4rem; align-items: center; padding: 0.25rem 0.55rem; border-radius: 999px; border: 1px solid transparent; font-size: 0.78rem; }
.label { font-weight: 700; }
.meta { opacity: 0.85; }
.tone-success { background: #dcfce7; color: #166534; border-color: #86efac; }
.tone-warning { background: #fffbeb; color: #92400e; border-color: #fcd34d; }
.tone-info { background: #eff6ff; color: #1d4ed8; border-color: #93c5fd; }
</style>

